import { Pipe, PipeTransform } from '@angular/core';
import { User, AuthState } from '../../store/auth/auth.state';

@Pipe({
  name: 'position',
  standalone: true
})
export class PositionPipe implements PipeTransform {
  transform(value: User | AuthState | null): string {
    if (value && 'user' in value) {
      value = (value as AuthState).user;
    }
    
    const user = value as User | null;
    if (!user || !user.role) return '';
    
    const roleMap: Record<string, string> = {
      'admin': 'Administrator',
      'staff': 'Staff Member',
      'citizen': 'Citizen',
      'user': 'User'
    };
    
    return roleMap[user.role.toLowerCase()] || user.role;
  }
} 